import React from 'react';
import {Link} from "react-router-dom";
import {withStore} from "../../../hocs";
import {observer} from "mobx-react";
import Select from "react-select";

// @ts-ignore
@withStore
@observer
export class FixMenuBottom extends React.Component {
    render() {

        // @ts-ignore
        const {store} = this.props;
        const {clientId,getUserId, templateTp, clientOpen, setClientOpen} = store?.mainStore;
        const {selectedClient, setSelectedOptionClient, optionsClient} = store?.mainStore;


        if(!getUserId()){
            return null;
        }

        if (clientOpen) {
            return (
                <>
                    <div className="fix-menu-bottom">
                        <div className="fix_menu_item-clients">
                            <Link to={'/client'}>
                                <div className="fix_svg"><img src="/img/svg/fix-menu/clients.svg" alt="alt"/></div>
                                <div className="fix_title">Клиенты</div>
                            </Link>
                        </div>
                        <div className="fix_menu_item-select">
                            <Select className="select header-select-top"
                                    classNamePrefix="react-select"
                                    value={selectedClient}
                                    onChange={setSelectedOptionClient}
                                    options={optionsClient}
                                    isDisabled={Boolean(!optionsClient?.length)}
                                    menuPlacement="top"
                            />
                        </div>
                        <div className="fix_menu_item-disable">
                            <div className="disable-filter-img " onClick={() => setClientOpen(false)}>
                                <svg width="12" height="12" className="disable-filter__img"
                                     viewBox="0 0 12 12"
                                     fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd"
                                          d="M1.42475 11.6154C1.08934 11.6154 0.753931 11.4879 0.498879 11.2311C-0.0129726 10.7192 -0.0129726 9.89119 0.498879 9.37934L8.87018 1.00803C9.38203 0.496183 10.2101 0.496183 10.7219 1.00803C11.2338 1.51989 11.2338 2.34793 10.7219 2.85978L2.35063 11.2311C2.09558 11.4879 1.76016 11.6154 1.42475 11.6154Z"
                                          fill="#082D64"/>
                                    <path fillRule="evenodd" clipRule="evenodd"
                                          d="M9.80036 11.6211C9.46495 11.6211 9.12954 11.4936 8.87448 11.2368L0.496193 2.85673C-0.0156582 2.34488 -0.0156582 1.51683 0.496193 1.00498C1.00979 0.493131 1.83784 0.493131 2.34794 1.00498L10.7262 9.38502C11.2381 9.89687 11.2381 10.7249 10.7262 11.2368C10.4712 11.4936 10.134 11.6211 9.80036 11.6211Z"
                                          fill="#082D64"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </>
            );
        }

        return (
            <>
                <div className="fix-menu-bottom">
                    <div className="fix_menu_item">
                        <Link to={'/catalog/'}>
                            <div className="fix_svg"><img src="/img/svg/fix-menu/catalog.svg" alt="alt"/></div>
                            <div className="fix_title">Каталог</div>
                        </Link>
                    </div>
                    {parseInt(clientId) ?
                        <>
                            <div className="fix_menu_item">
                                <Link to={'/basket'}>
                                    <div className="fix_svg"><img src="/img/svg/fix-menu/basket.svg" alt="alt"/></div>
                                    <div className="fix_title">Корзина</div>
                                </Link>
                            </div>
                        </> : null}
                    <div className="fix_menu_item">
                        <Link to={'/order'}>
                            <div className="fix_svg"><img src="/img/svg/fix-menu/order.svg" alt="alt"/></div>
                            <div className="fix_title">Заказы</div>
                        </Link>
                    </div>
                    <div className="fix_menu_item">
                        <Link to={'/commercial'}>
                            <div className="fix_svg"><img src="/img/svg/fix-menu/pensil.svg" alt="alt"/></div>
                            <div className="fix_title">Условия</div>
                        </Link>
                    </div>

                    {templateTp ? <div className="fix_menu_item">
                        <div onClick={() => setClientOpen(true)}>
                            <div className="fix_svg"><img src="/img/svg/fix-menu/clients.svg" alt="alt"/></div>
                            <div className="fix_title">Клиенты</div>
                        </div>
                    </div> : null}
                    <div className="fix_menu_item">
                        <Link to={'/return'}>
                            <div className="fix_svg"><img src="/img/svg/fix-menu/return.svg" alt="alt"/></div>
                            <div className="fix_title">Возврат</div>
                        </Link>
                    </div>
                </div>
            </>
        );
    }
}


